import React, { ReactElement } from 'react';
import { Text } from '@amzn/storm-ui';
import { CustomFormRow } from './style';

interface ReadOnlyFormFieldProps {
  label: string;
  id: string;
  value?: string;
  labelTopSpacing?: string;
  helpTipText?: string;
  children?: ReactElement;
}

const ReadOnlyFormField = ({
  label,
  id,
  value,
  labelTopSpacing = '0px',
  helpTipText,
  children,
}: ReadOnlyFormFieldProps) => {
  return (
    <CustomFormRow
      viewMode={true}
      label={label}
      labelTopSpacing={labelTopSpacing}
      helpTipText={helpTipText}
      id={id}
      controlComponents={[
        (componentId: string) => (
          <>
            {children ? (
              children
            ) : (
              <Text
                id={componentId}
                data-testid={`${id}-value`}
                color="secondary"
              >
                {value}
              </Text>
            )}
          </>
        ),
      ]}
    />
  );
};

export default ReadOnlyFormField;
